import { AppContext } from "@/App.context";
import config from "@/config";
import {
  API_NO_DATA_FOUND_ERROR,
} from "@/lib/errors/error-constants";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export const getStatisticsTagging = (token) => {
  return async ({ service,id }) => {
    // return dummy
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/virtual-tag/delete?Id=${id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }
    const res = await owners.json();
    return res;
  };
};

/**
 * @param {GetStatisticsCostAnomalyReq} req
 * @param {any[]=} deps
 */
export const useTagsDelete = (req, deps = [],enabled=true) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getStatisticsTagging", req, ...deps],
    queryFn: () => getStatisticsTagging(appContext.idToken)(req),
    retry:false,
    enabled
  });
  return query;
};
